/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestRawDev from '@/utils/requestRawDev'
import requestDev from '@/utils/requestDev'
import { APIReportPHP, APICore } from '@/utils/servicesApi'
const qs = require('qs')

export function updateBank(data) {
    return requestRaw({
        url: APICore() + '/zeus/member/account/update-bank',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function getTimezones() {
    return requestRaw({
        url: APICore() + '/zeus/member/account/timezones',
        method: 'GET',
    })
}

export function updatePassword(data) {
    return requestRaw({
        url: APICore() + '/zeus/member/account/update-password',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function updateTimezone(data) {
    return requestRaw({
        url: APICore() + '/zeus/member/account/update-timezone',
        method: 'POST',
        data: data // untuk array data post
    })
}
export function updateProfile(data) {
    return requestRaw({
        url: APICore() + '/zeus/member/account/update-profile',
        method: 'POST',
        data: data // untuk array data post
    })
}

export function monthlyAgentsStatistic(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/member/monthly_agents_statistic',
        method: 'POST',
        data: qs.stringify(params)
    })
}


export function summaryAgents(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/member/summary_agents',
        method: 'POST',
        data: qs.stringify(params)
    })
}


export function monthlyActiveLicenses(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/member/monthly_active_licenses',
        method: 'POST',
        data: qs.stringify(params)
    })
}


export function getActiveVoucherTotal() {
    return requestRawDev({
        url: APIReportPHP() + '/zeus/member/active_voucher_total',
        method: 'GET',
    })
}

export function getLicenseTotal() {
    return requestRawDev({
        url: APIReportPHP() + '/zeus/member/license_total',
        method: 'GET',
    })
}

export function getAgentTotal() {
    return requestRawDev({
        url: APIReportPHP() + '/zeus/member/agent_total',
        method: 'GET',
    })
}

export function getMessageTotal(params) {
    return requestRawDev({
        url: APIReportPHP() + '/zeus/member/message_total?provider=' + params.provider,
        method: 'GET',
    })
}

export function getMessageSuccess(params) {
    return requestRawDev({
        url: APIReportPHP() + '/zeus/member/message_success_total?provider=' + params.provider,
        method: 'GET',
    })
}
export function getMessagePending(params) {
    return requestRawDev({
        url: APIReportPHP() + '/zeus/member/message_pending_total?provider=' + params.provider,
        method: 'GET',
    })
}

export function getMessageError(params) {
    return requestRawDev({
        url: APIReportPHP() + '/zeus/member/message_error_total?provider=' + params.provider,
        method: 'GET',
    })
}
//member
export function listDataMemberExcel(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/member/all_member_excel',
        method: 'POST',
        data: qs.stringify(params)
    })
}

//member
export function listDataMember(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/member/all_member',
        method: 'POST',
        data: qs.stringify(params)
    })
}

export function listLicenseActive(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/report_member/list_license_active',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listLicenseActiveExcel(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/report_member/list_license_active_excel',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listReseller(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/report_member/list_affiliate',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listSaldoReseller(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/report_member/list_saldo_affiliate',
        method: 'POST',
        data: qs.stringify(params)
    })
}
export function listDownline(params) {
    return requestDev({
        url: APIReportPHP() + '/zeus/report_member/list_downline',
        method: 'POST',
        data: qs.stringify(params)
    })
}

// Konfirmasi akun member oleh administrator (tanpa OTP).
// Backend memvalidasi token admin + password admin.
export function confirmMemberAccount(data) {
    return requestRaw({
        url: APICore() + '/zeus/member/confirm-account',
        method: 'POST',
        data: data,
        silent: true
    })
}

// Membuat sesi member untuk impersonation. Response hanya berisi kode handoff
// sekali pakai, bukan JWT member.
export function createMemberImpersonation(data) {
    return requestRaw({
        url: APICore() + '/zeus/member/impersonate',
        method: 'POST',
        data: data,
        silent: true
    })
}




// WEBPACK FOOTER //
// ./src/api/member.js